import { create } from 'zustand';

/**
 * Связывает оглавление «Обучение» в сайдбаре со страницей обучения.
 *
 * - sidebar пишет `requestedStep` при клике по этапу → страница ловит и скроллит к секции.
 * - страница пишет `activeStep` при скролле (IntersectionObserver) → сайдбар подсвечивает.
 *
 * Используется два разных поля специально: requestedStep — «команда проскроллить»
 * (с монотонным nonce, чтобы повторный клик по тому же этапу тоже сработал),
 * activeStep — «что сейчас видно» (для подсветки). Если бы поле было одно,
 * клик-скролл и скролл-подсветка дёргали бы друг друга по кругу.
 */
export interface GettingStartedState {
  /** id этапа, который сейчас в зоне видимости (для подсветки в сайдбаре) */
  activeStep: string | null;
  /** id этапа, к которому попросили проскроллить (клик в сайдбаре) */
  requestedStep: string | null;
  /** растёт при каждом клике — чтобы повторный клик по активному этапу тоже сработал */
  requestNonce: number;
  setActiveStep: (id: string | null) => void;
  requestStep: (id: string) => void;
}

export const useGettingStartedStore = create<GettingStartedState>((set) => ({
  activeStep: null,
  requestedStep: null,
  requestNonce: 0,
  setActiveStep: (id) => set({ activeStep: id }),
  requestStep: (id) =>
    set((s) => ({ requestedStep: id, requestNonce: s.requestNonce + 1 })),
}));
